export enum ERouterName {
    ELEMENT = 'element',
    LOGIN = 'login',
    PROJECT = 'project',
    HOME = 'home',
    TSA = 'tsa',
    SETTING = 'setting',
    LAYER = 'layer',
    PHOTO = 'photo',
    MEDIA = 'media',
    WAYLINE = 'wayline',
    LIVESTREAM = 'livestream',
    LIVE = 'live',
    LIVING = 'living',
    WORKSPACE = 'workspace',
    MEMBERS = 'members',
    DEVICES = 'devices',
    TASK = 'task',
    CREATE_PLAN = 'create-plan',
    SELECT_PLAN = 'select-plan',
    FIRMWARES = 'firmwares',
    DASHBOARD = 'dashboard',
    DASHBOARD_XA = 'dashboard-xa',
    DASHBOARD_DK = 'dashboard-dk',
    FLIGHT_AREA = 'flight-area',
    MODEL = 'model',
    MODEL_IMPORT = 'model-import',
    CREATE_MODEL = 'create-model',
    SELECT_MODEL = 'select-model',

    PILOT = 'pilot-login',
    PILOT_HOME = 'pilot-home',
    PILOT_MEDIA = 'pilot-media',
    PILOT_LIVESHARE = 'pilot-liveshare',
    PILOT_BIND = 'pilot-bind',
    AI = 'ai',
    ALGORITHMS = 'algorithms',
    INSPECT = 'inspect',
    RECORD = 'record',
    CREATE_WAYLINE = 'create-wayline',
    EDIT_WAYLINE = 'edit-wayline',
    EDIT_WAYLINE2D = 'edit-wayline2d',
    EDIT_WAYLINE2D_CIRCLE = 'edit-wayline2d-circle',
    EDIT_WAYLINE3D = 'edit-wayline3d',
    EDIT_WAYLINECIRCLE = 'edit-wayline-circle',
    EDIT_WAYLINEMATCH = 'edit-wayline-match',
    EDIT_WAYLINEINSPECT = 'edit-wayline-inspect',
    EDIT_WAYLINEENTIRE = 'edit-wayline-entire',
}

export enum EStorageKey {
    LANG_CODE = 'DJI_CREATE_VITE_H5_APP:lang_code',
    TEST_TOOLS_POSITION_STORAGE_KEY = 'DJI_CREATE_VITE_H5_APP:test_tools_position',
    SESSION_ID = 'DJI_CREATE_VITE_H5_APP:sess'
}

export enum EStatusValue {
    CONNECTED = 'Connected',
    DISCONNECT = 'Disconnect',
    LIVING = 'Living'
}

export enum ELiveStatusValue {
    DISCONNECT,
    CONNECTED,
    LIVING
}

export enum EComponentName {
    Thing = 'thing',
    Liveshare = 'liveshare',
    Api = 'api',
    Ws = 'ws',
    Map = 'map',
    Tsa = 'tsa',
    Media = 'media',
    Mission = 'mission'
}

export enum ELocalStorageKey {
    Username = 'username',
    WorkspaceId = 'workspace_id',
    Token = 'x-auth-token',
    LoginInfo = 'login_info',
    PlatformName = 'platform_name',
    WorkspaceName = 'workspace_name',
    WorkspaceDesc = 'workspace_desc',
    WorkspaceLogo = 'workspace_logo',
    Flag = 'flag',
    UserId = 'user_id',
    RoleType = 'role_type',
    Device = 'device',
    GatewayOnline = 'gateway_online',
    DockInfo = 'dock_info',
    DockOsdInfo = 'dock_osd_info'
}

export enum EPhotoType {
    Original = 0,
    Preview = 1,
    Unknown = -1
}

export enum EDownloadOwner {
    Mine = 0,
    Others = 1,
    Unknown = -1
}

export enum EUserType {
    Web = 1,
    Pilot = 2,
}

export enum ERoleType {
    Admin = 1,
    Member = 2,
}

export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    DockOsd = 'dock_osd',
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',

    // 机场任务
    FlightTaskProgress = 'flighttask_progress', // 机场任务执行进度
    FlightTaskMediaProgress = 'file_upload_callback', // 机场任务媒体上传进度
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // 机场任务媒体优先级上报

    // 设备指令
    DeviceReboot = 'device_reboot', // 机场重启
    DroneOpen = 'drone_open', // 飞行器开机
    DroneClose = 'drone_close', // 飞行器关机
    DeviceFormat = 'device_format', // 机场数据格式化
    DroneFormat = 'drone_format', // 飞行器数据格式化
    CoverOpen = 'cover_open', // 打开舱盖
    CoverClose = 'cover_close', // 关闭舱盖
    PutterOpen = 'putter_open', // 推杆展开
    PutterClose = 'putter_close', // 推杆闭合
    ChargeOpen = 'charge_open', // 打开充电
    ChargeClose = 'charge_close', // 关闭充电

    // 设备升级
    DeviceUpgrade = 'ota_progress', // 设备升级

    // 设备日志
    DeviceLogUploadProgress = 'fileupload_progress', // 设备日志上传

    // 飞行指令消息
    ControlSourceChange = 'control_source_change', // 控制权更新
    FlyToPointProgress = 'fly_to_point_progress', // 飞向目标点
    TakeoffToPointProgress = 'takeoff_to_point_progress', // 一键起飞
    CameraPhotoTakeProgress = 'camera_photo_take_progress', // 全景拍照
    PsdkFloatingWindowText = 'psdk_floating_window_text', // psdk-浮窗文本推送
    SpeakerAudioPlayStartProgress = 'speaker_audio_play_start_progress', // 喊话器-音频播放进度通知
    SpeakerTtsPlayStartProgress = 'speaker_tts_play_start_progress', // 喊话器-tts播放进度通知
    JoystickInvalidNotify = 'joystick_invalid_notify', // 设备端退出drc模式
    DrcStatusNotify = 'drc_status_notify', // 飞行控制模式状态

    // custom flight area
    FlightAreasSyncProgress = 'flight_areas_sync_progress',
    FlightAreasDroneLocation = 'flight_areas_drone_location',
    FlightAreasUpdate = 'flight_areas_update',

    // 设备报警
    DeviceInspect = 'device_inspect',
}

export const EBizCodeName = {
  [EBizCode.CameraPhotoTakeProgress]: '全景拍照进度',
  [EBizCode.TakeoffToPointProgress]: '一键起飞进度',
  [EBizCode.FlyToPointProgress]: '飞向目标点进度',
  [EBizCode.JoystickInvalidNotify]: '设备端退出drc模式',
}

export const ECameraName = {
  wide: '广角',
  zoom: '变焦',
  ir: '红外',
}

export enum EDeviceTypeName {
    Aircraft = 0,
    Gateway = 2,
    Dock = 3,
    Land = 4,
    Gb28281 = 5,
    Zerone = 6,
    Target = 7
}

export enum EHmsLevel {
    NOTICE,
    CAUTION,
    WARN,
}
